import { UserRoleType } from "../current-user/user-role-type.enum";
import { UserTypeResponseModel } from "./user-type-response.model";

export class UserAccessResponseModel {
        public email? : string;
        public username? : string;
        public groupCode? : string;
        public roles: UserRoleType[] = [];
        public userTypes: UserTypeResponseModel[] = [];
}